import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyC6FWuNQWoJdRRPKSrafyl4WmixiR52VMQ",
    authDomain: "linkedin-build-db.firebaseapp.com",
    projectId: "linkedin-build-db",
    storageBucket: "linkedin-build-db.appspot.com",
    messagingSenderId: "262666206751",
    appId: "1:262666206751:web:ee30dabe4e6367d1b41f2a"
  };

  const firebaseApp = firebase.initializeApp(firebaseConfig);
  const db = firebaseApp.firestore();
  const auth = firebase.auth();

  export { db, auth };